export default __webpack_public_path__ + "locales/bg/InviteDialog.json?hash=7f8e4b4ce02cbaf4cc9588d3c42eae8f";